import { render, staticRenderFns } from "./PgpEditRedirectLink.vue?vue&type=template&id=5251cce6&"
import script from "./PgpEditRedirectLink.vue?vue&type=script&lang=js&"
export * from "./PgpEditRedirectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports